export default __webpack_public_path__ + "static/media/20s_bg_desktop@2x.6f3c9ef9.jpg";